import { render, staticRenderFns } from "./LeaveResearchGroup.html?vue&type=template&id=e6d2d510&scoped=true&external"
import script from "./LeaveResearchGroup.vue?vue&type=script&lang=js"
export * from "./LeaveResearchGroup.vue?vue&type=script&lang=js"
import style0 from "./LeaveResearchGroup.scss?vue&type=style&index=0&id=e6d2d510&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d2d510",
  null
  
)

export default component.exports